import { FunctionComponent } from 'react';

export const TeamMapAnimation: FunctionComponent = () => {
  return (
    <object
      className="team-map"
      type="image/svg+xml"
      data={require('../../../public/img/team_map.svg')?.default?.src}
    >
      svg-animation
    </object>
  );
};
